import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class OcrScannedDocReportQueryCriteriaClass extends BaseCriteriaModel {
    app_file_item_guid?: Optional<string> = Optional.empty();
    algorithm_provider?: Optional<string> = Optional.empty();
    login_subject_guid?: Optional<string> = Optional.empty();
    entity_hdr_guid?: Optional<string> = Optional.empty();
    membership_hdr_guid?: Optional<string> = Optional.empty();
    website_hdr_guid?: Optional<string> = Optional.empty();
    guids?: Optional<string[]> = Optional.empty();
    process_status?: Optional<string> = Optional.empty();
    scanned_doc_no?: Optional<string> = Optional.empty();
    created_date_from?: Optional<string> = Optional.empty();
    updated_date_to?: Optional<string> = Optional.empty();
    updated_date_from?: Optional<string> = Optional.empty();
    created_date_to?: Optional<string> = Optional.empty();
    created_by_subject_guid?: Optional<string[]> = Optional.empty();
    line_ocr_scanned_doc_hdr_guid?: Optional<string> = Optional.empty();
}